// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useControllerContext } from '@tectonics/controller/context';
import { isLocalLatamTenantCode } from '@tectonics/commons/tenant';
import { getCountry, useIncomingPayment } from '@tectonics/prs/incoming-payment';

export function BrazilianTermsForCrossBorder(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);
  const { localTenancy } = useControllerContext();

  if (country !== 'br' || isLocalLatamTenantCode(localTenancy)) {
    return null;
  }

  return (
    <Paragraph>
      Esta é uma compra internacional, mediante operação de câmbio, que será intermediada pelo EBANX de acordo com seus
      {'\u00A0'}
      <a href="https://www.ebanx.com/br/termos" target="_blank" rel="noopener noreferrer">
        termos e condições.
      </a>
      <br />
      Ao clicar em pagar, você dá ciência e aceita os termos desta transação.
    </Paragraph>
  );
}

const Paragraph = styled.p`
  font-size: .86em;
  color: #b0b0b0;
  margin: 20px 0 0 0;
  @media (max-width: 990px) {
    margin: 20px 10px 0 10px;
  }
`;
